var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('b-tabs',{attrs:{"content-class":"mt-1","align":"center"}},[_c('b-tab',{attrs:{"title":"Saldos Adicionados"}},[_c('BalanceHistory')],1),_c('b-tab',{attrs:{"title":"Reembolsos"}},[_c('BalanceHistoryRefund')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }